import createIcon from '@/lib/create-icon'

const HandMoneyIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      d='M15.75 16.75L19.578 15.3157C20.0553 15.1476 20.6207 15.3064 20.8617 15.7418C21.189 16.3328 20.9025 16.9845 20.3465 17.2016L13.5437 20.1251C12.9874 20.3721 12.3834 20.5 11.7725 20.5C10.997 20.5 10.2361 20.2942 9.57125 19.9048L7.66712 18.7897C7.22767 18.5324 6.5108 18.3881 6 18.37M6 13.75H8.39792C9.27954 13.75 10.1414 14.011 10.875 14.5C11.6086 14.989 12.4705 15.25 13.3521 15.25H14.625C15.2463 15.25 15.75 15.7537 15.75 16.375C15.75 16.9963 15.2463 17.5 14.625 17.5H11.25M16 6.125V5.5M16 6.125C16.3453 6.125 16.6651 6.15967 16.8669 6.57071M16 6.125C15.534 6.125 15 6.26207 15 7.00143C15 7.40429 15.22 7.75571 15.5314 7.85357L16.4686 8.14786C16.7806 8.24643 17 8.59714 17 9C17 9.73934 16.4666 9.87714 16.0006 9.87714C15.6546 9.87714 15.3343 9.84068 15.1326 9.42857M16 9.875V10.5M4 19H5C5.55228 19 6 18.5523 6 18V14C6 13.4477 5.55228 13 5 13H4C3.44772 13 3 13.4477 3 14V18C3 18.5523 3.44772 19 4 19ZM21 8C21 10.7614 18.7614 13 16 13C13.2386 13 11 10.7614 11 8C11 5.23858 13.2386 3 16 3C18.7614 3 21 5.23858 21 8Z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'HandMoneyIcon'
)

export default HandMoneyIcon
